import { useSelector } from "react-redux";

function useExchangePortfolioInfo() {
  const {
    exchangeState: {
      portfolioData,
      balanceChartData,
      portfolioLoading,
      balanceChartStatus,
    },
  } = useSelector((state) => state);

  const totalBalance = portfolioData.reduce((acc, cur) => {
    return (
      parseFloat(cur?.availableBalanceUSD) +
      parseFloat(cur?.stakingBalanceUSD) +
      acc
    );
  }, 0);

  const {
    BALANCE_CHANGE_PERCENTAGE_24H: balanceChangePercent24H,
    BALANCE_CHANGE_USD_24H: balanceChangeUSD24H,
    BALANCE_CHANGE_PERCENTAGE_7D: balanceChangePercent7D,
    BALANCE_CHANGE_USD_7D: balanceChangeUSD7D,
  } = balanceChartData;

  const balanceChange = {
    "24h": {
      percent: balanceChangePercent24H || 0,
      usd: balanceChangeUSD24H || 0,
    },
    "7d": {
      percent: balanceChangePercent7D || 0,
      usd: balanceChangeUSD7D || 0,
    },
  };

  const balanceLoading = balanceChartStatus === "loading";

  return {
    totalBalance,
    balanceChange,
    portfolioLoading,
    balanceLoading,
    portfolioData,
  };
}

export default useExchangePortfolioInfo;
